export const GET_BRAND_REPORT = "GET_BRAND_REPORT";

export const BRAND_SEARCH_DEBOUNCE_MS = 500;
export const BRAND_REPORT_INFO_TOAST_DURATION_MS = 4000;

export const BRAND_REPORT_SECTION_TITLE = {
  POS: "POS",
  ONLINE: "ONLINE",
};

export const BRAND_REPORT_LABELS = {
  TOTAL_SENT: "TOTAL SENT",
  SEARCH_BRANDS: "Search Brands",
  REFRESH: "Refresh",
  KEY_INSIGHTS: "Key Insights",
  COMPLETION_TYPE_BREAKDOWN: "Completion Type Breakdown",
  PLEASE_SEARCH_BRAND: "Please search a brand to view the report.",
  NO_DATA_AVAILABLE: "No data available for POS or Online channels.",
};

export const BRAND_REPORT_PROGRESS_LABELS = {
  SURVEYS_OPENED: "Surveys Opened",
  SURVEYS_STARTED: "Surveys Started",
  SURVEYS_COMPLETED: "Surveys Completed",
};

export const BRAND_REPORT_BREAKDOWN_LABELS = {
  POSITIVE: "Positive",
  PASSIVE: "Passive",
  NEGATIVE: "Negative",
  REDIRECT_TO_GOOGLE_REVIEW: "Redirect to Google Review",
};

export const BRAND_REPORT_INSIGHT_TITLES = {
  TOTAL_SURVEYS: "Total Surveys",
  OVERALL_COMPLETION: "Overall Completion",
  POSITIVE_RESPONSE: "Positive Response",
  BEST_CHANNEL: "Best Channel",
  ACTIVE_CHANNEL: "Active Channel",
};

export const BRAND_REPORT_CHANNEL = {
  POS: "POS",
  ONLINE: "Online",
  BALANCED: "Balanced",
};

export const BRAND_REPORT_INSIGHT_COPY = {
  COMPLETION_RATE: "Completion rate",
  TOTAL_SURVEYS_VIA_POS: "Total sent via POS",
  OF_COMPLETED_SURVEYS: "Of completed surveys",
  HIGHER_COMPLETION_RATE: "higher completion rate",
  TOTAL_SURVEYS_VIA_ONLINE: "Total sent via Online",
  AVERAGE_COMPLETION_RATE: "Average completion rate",
  PRIMARY_FEEDBACK_SOURCE: "Primary feedback source",
  TOTAL_SURVEYS_COMBINED: "Combined across both channels",
  COMPLETION_RATES_SAME: "Completion rates are the same.",
};
